import React from 'react';
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalBody,
  Text,
  Image,
  Flex,
} from '@chakra-ui/react';
import { useTranslation } from 'react-i18next';

interface PowerRewardModalProps {
  isOpen: boolean;
  onClose: () => void;
  amount: number;
  reason: 'connect' | 'play' | 'share';
}

export const PowerRewardModal: React.FC<PowerRewardModalProps> = ({
  isOpen,
  onClose,
  amount,
  reason,
}) => {
  const { t } = useTranslation();

  const getRewardTitle = () => {
    switch (reason) {
      case 'connect':
        return t('rewards.connect.title');
      case 'play':
        return t('rewards.play.title');
      case 'share':
        return t('rewards.share.title');
    }
  };

  const getRewardDescription = () => {
    switch (reason) {
      case 'connect':
        return t('rewards.connect.description');
      case 'play':
        return t('rewards.play.description');
      case 'share':
        return t('rewards.share.description');
    }
  };

  return (
    <Modal 
      isOpen={isOpen} 
      onClose={onClose} 
      isCentered
      aria-labelledby="reward-modal-title"
      aria-describedby="reward-modal-description"
    >
      <ModalOverlay 
        bg="rgba(0, 0, 0, 0.8)"
        backdropFilter="blur(2px)"
      />
      <ModalContent
        bg="#F5EFEA"
        borderRadius="xl"
        maxW="320px"
        mx={4}
      >
        <ModalBody p={6}>
          <Flex direction="column" align="center">
            <Image 
              src={process.env.PUBLIC_URL + "/power210.svg"} 
              w="64px" 
              mb={4}
              alt="Power reward icon"
            />
            <Text
              id="reward-modal-title"
              fontSize="18px"
              textAlign="center"
              mb={2}
            >
              {getRewardTitle()}
            </Text>
            <Flex
              fontSize="14px"
              textAlign="center"
              color="gray.600"
              mb={2}
              align="center"
            >
              <Text fontSize="24px" fontFamily="silkscreen" color="black" mr={1}>+{amount}</Text>
              <Text>GBP</Text>
            </Flex>
            <Text
              id="reward-modal-description"
              fontSize="14px"
              textAlign="center"
              color="gray.600"
            >
              {getRewardDescription()}
            </Text>
          </Flex>
        </ModalBody>
      </ModalContent>
    </Modal>
  );
};